'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icon = function icon(open) {
  var style = _styles2.default.icon;

  if (open) {
    style = (0, _combineStyles2.default)(style, { transform: 'rotate(180deg) translateY(50%)' });
  }

  return style;
};

var header = function header() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _colors2.default.theme;
  var overrideStyle = arguments[2];

  var style = (0, _combineStyles2.default)(_styles2.default.header, {
    backgroundColor: color,
    ':hover': {
      backgroundColor: (0, _darken2.default)(color, 0.05)
    },
    ':active': {
      backgroundColor: (0, _darken2.default)(color, 0.15)
    }
  });

  if (errorMessage) {
    style = (0, _combineStyles2.default)(style, { border: '1px solid ' + _colors2.default.error });
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

var error = function error(overrideStyle) {
  return (0, _combineStyles2.default)(_styles2.default.error, overrideStyle);
};

exports.default = { icon: icon, header: header, error: error };
module.exports = exports.default;